import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from '@emotion/styled';
import { toast } from 'react-toastify';

import UploadFile from './UploadFile';
import PreviewFile from './PreviewFile';
import UploadSkuSettings from './UploadSkuSettings';

import { parseError } from '../../../helpers';

import {
  fetchUpdateImportTask,
  fetchStartTaskProcess,
  fetchGetFieldList,
} from '../../../actions/imports';

const Wrapper = styled('div')`
  .files-wrapper {
    display: flex;
    flex-wrap: wrap;
  }
  .dropzone {
    padding: 0;
    padding: 5px;
    min-height: 100px;
    cursor: pointer;
    background-color: #ffffff;
    border: 2px dashed rgba(50, 58, 70, 0.3);
    &.with-text {
      width: 100%;
    }
    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
      transition-duration: 0.3s;
    }
  }
  .grey-background {
    background: #f1f5f7;
  }
`;

const XlsImport = (props) => {
  const {
    templateType,
    withoutTemplate,
    templateFileName,
    successMessage,
    successRoute,
    errorMessage,
    importType,
  } = props;

  const dispatch = useDispatch();
  const history = useHistory();

  const [importData, setImportData] = useState(null);
  const [matchingOptions, setMatchingOptions] = useState([]);
  const [matchingValues, setMatchingValues] = useState({});

  useEffect(() => {
    (async function () {
      const fieldMatching = await dispatch(fetchGetFieldList(templateType));
      const newOptions = Object.keys(fieldMatching)
        .map((key) => ({
          value: key,
          label: fieldMatching[key],
        }))
        .sort((a, b) => {
          return a.label > b.label ? 1 : a.label < b.label ? -1 : 0;
        });
      newOptions.unshift({ value: null, label: 'Не загружать' });
      setMatchingOptions(newOptions);
    })();
  }, []);

  const handleCreateTask = async (values) => {
    const taskData = {
      ...values,
      id: importData.id,
      fieldMatching: Object.keys(matchingValues).reduce((a, key) => {
        if (matchingValues[key] !== null) {
          a[matchingValues[key]] = importData.header[key].title;
        }
        return a;
      }, {}),
    };

    await dispatch(fetchUpdateImportTask(taskData));

    dispatch(fetchStartTaskProcess(importData.id))
      .then(() => {
        toast.info(successMessage);
        history.push(successRoute);
      })
      .catch((err) => {
        toast.error(`${errorMessage}: ${parseError(err)}`);
      });
  };

  return (
    <Wrapper>
      <div className="card">
        <div className="card-body">
          <UploadFile
            templateType={templateType}
            withoutTemplate={withoutTemplate}
            templateFileName={templateFileName}
            setImportData={setImportData}
            importType={importType}
          />
          {importData && importType !== 'chz' ? (
            <>
              <UploadSkuSettings
                templateType={templateType}
                importData={importData}
                handleCreateTask={handleCreateTask}
              />
              <PreviewFile
                importData={importData}
                matchingOptions={matchingOptions}
                matchingValues={matchingValues}
                setMatchingValues={setMatchingValues}
              />
            </>
          ) : null}
        </div>
      </div>
    </Wrapper>
  );
};

export default XlsImport;
